import { Route, Routes } from "react-router-dom";
import TakyonServicesTemplate from "./takyon_services_template";
import { useTranslation } from "react-i18next";

export default function TakyonServicesRouter() {
  const { t } = useTranslation();

  return (
    <Routes>
      <Route
        path="be_setup"
        element={
          <TakyonServicesTemplate
            image=""
            title={t("collection.service.be_setup.title")}
            subtitle={t("collection.service.be_setup.subtitle")}
            buttonText={t("collection.service.be_setup.buttonText")}
            buttonLink={{
              type: 0,
              link: "https://meetings-eu1.hubspot.com/simona-graziani?uuid=450ae869-e0ec-4daa-831c-a836e49a76b9",
              modalTxt: t("collection.service.be_setup.modalText"),
            }}
            buttonSubtext={""}
            descriptionTitle={t("collection.service.be_setup.descriptionTitle")}
            descriptionText={t("collection.service.be_setup.descriptionText")}
            features={[
              {
                title: t("collection.service.be_setup.features.0.title"),
                description: t(
                  "collection.service.be_setup.features.0.description"
                ),
              },
              {
                title: t("collection.service.be_setup.features.1.title"),
                description: t(
                  "collection.service.be_setup.features.1.description"
                ),
              },
              {
                title: t("collection.service.be_setup.features.2.title"),
                description: t(
                  "collection.service.be_setup.features.2.description"
                ),
              },
            ]}
            faq={[
              {
                question: t("collection.service.be_setup.faq.0.question"),
                answer: t("collection.service.be_setup.faq.0.answer"),
              },
              {
                question: t("collection.service.be_setup.faq.2.question"),
                answer: t("collection.service.be_setup.faq.2.answer"),
              },
              {
                question: t("collection.service.be_setup.faq.1.question"),
                answer: t("collection.service.be_setup.faq.1.answer"),
              },
              {
                question: t("collection.service.be_setup.faq.3.question"),
                answer: t("collection.service.be_setup.faq.3.answer"),
              },
            ]}
          />
        }
      />
      <Route
        path="resellable_rate"
        element={
          <TakyonServicesTemplate
            title={t("collection.service.resellable_rate.title")}
            subtitle={t("collection.service.resellable_rate.subtitle")}
            buttonText={t("collection.service.resellable_rate.buttonText")}
            buttonLink={{
              type: 0,
              // `https://meetings-eu1.hubspot.com/marco-amodio?uuid=ad7ddb3e-4b41-415e-ab87-e7697321868e`,
              link: "https://meetings-eu1.hubspot.com/simona-graziani?uuid=450ae869-e0ec-4daa-831c-a836e49a76b9",
              // "https://meetings-eu1.hubspot.com/marco-amodio",
            }}
            buttonSubtext={""}
            descriptionTitle={t(
              "collection.service.resellable_rate.descriptionTitle"
            )}
            descriptionText={t(
              "collection.service.resellable_rate.descriptionText"
            )}
            features={[
              {
                title: t("collection.service.resellable_rate.features.0.title"),
                description: t(
                  "collection.service.resellable_rate.features.0.description"
                ),
              },
              {
                title: t("collection.service.resellable_rate.features.1.title"),
                description: t(
                  "collection.service.resellable_rate.features.1.description"
                ),
              },
              {
                title: t("collection.service.resellable_rate.features.2.title"),
                description: t(
                  "collection.service.resellable_rate.features.2.description"
                ),
              },
              {
                title: t("collection.service.resellable_rate.features.3.title"),
                description: t(
                  "collection.service.resellable_rate.features.3.description"
                ),
              },
            ]}
            faq={[
              {
                question: t(
                  "collection.service.resellable_rate.faq.0.question"
                ),
                answer: t("collection.service.resellable_rate.faq.0.answer"),
              },
              {
                question: t(
                  "collection.service.resellable_rate.faq.1.question"
                ),
                answer: t("collection.service.resellable_rate.faq.1.answer"),
              },
              {
                question: t(
                  "collection.service.resellable_rate.faq.2.question"
                ),
                answer: t("collection.service.resellable_rate.faq.2.answer"),
              },
              {
                question: t(
                  "collection.service.resellable_rate.faq.3.question"
                ),
                answer: t("collection.service.resellable_rate.faq.3.answer"),
              },
              {
                question: t(
                  "collection.service.resellable_rate.faq.4.question"
                ),
                answer: t("collection.service.resellable_rate.faq.4.answer"),
              },
            ]}
          />
        }
      />
      <Route
        path="takyonic"
        element={
          <TakyonServicesTemplate
            title={t("collection.service.takyonic.title")}
            subtitle={t("collection.service.takyonic.subtitle")}
            buttonText={t("collection.service.takyonic.buttonText")}
            buttonLink={{ type: 1, link: "loyalty" }}
            buttonSubtext={""}
            descriptionTitle={t("collection.service.takyonic.descriptionTitle")}
            descriptionText={t("collection.service.takyonic.descriptionText")}
            features={[
              {
                title: t("collection.service.takyonic.features.0.title"),
                description: t(
                  "collection.service.takyonic.features.0.description"
                ),
              },
              {
                title: t("collection.service.takyonic.features.1.title"),
                description: t(
                  "collection.service.takyonic.features.1.description"
                ),
              },
              {
                title: t("collection.service.takyonic.features.2.title"),
                description: t(
                  "collection.service.takyonic.features.2.description"
                ),
              },
              {
                title: t("collection.service.takyonic.features.3.title"),
                description: t(
                  "collection.service.takyonic.features.3.description"
                ),
              },
            ]}
            faq={[
              {
                question: t("collection.service.takyonic.faq.0.question"),
                answer: t("collection.service.takyonic.faq.0.answer"),
              },
              {
                question: t("collection.service.takyonic.faq.1.question"),
                answer: t("collection.service.takyonic.faq.1.answer"),
              },
              {
                question: t("collection.service.takyonic.faq.2.question"),
                answer: t("collection.service.takyonic.faq.2.answer"),
              },
              {
                question: t("collection.service.takyonic.faq.3.question"),
                answer: t("collection.service.takyonic.faq.3.answer"),
              },
              {
                question: t("collection.service.takyonic.faq.4.question"),
                answer: t("collection.service.takyonic.faq.4.answer"),
              },
              {
                question: t("collection.service.takyonic.faq.5.question"),
                answer: t("collection.service.takyonic.faq.5.answer"),
              },
            ]}
          />
        }
      />
      <Route
        path="marketing"
        element={
          <TakyonServicesTemplate
            title={t("collection.service.marketing.title")}
            subtitle={t("collection.service.marketing.subtitle")}
            buttonText={t("collection.service.marketing.buttonText")}
            buttonLink={{
              type: 0,
              link: "https://meetings-eu1.hubspot.com/simona-graziani",
            }}
            buttonSubtext={""}
            descriptionTitle={t(
              "collection.service.marketing.descriptionTitle"
            )}
            descriptionText={t("collection.service.marketing.descriptionText")}
            features={[
              {
                title: t("collection.service.marketing.features.0.title"),
                description: t(
                  "collection.service.marketing.features.0.description"
                ),
              },
              {
                title: t("collection.service.marketing.features.1.title"),
                description: t(
                  "collection.service.marketing.features.1.description"
                ),
              },
              {
                title: t("collection.service.marketing.features.2.title"),
                description: t(
                  "collection.service.marketing.features.2.description"
                ),
              },
              {
                title: t("collection.service.marketing.features.3.title"),
                description: t(
                  "collection.service.marketing.features.3.description"
                ),
              },
            ]}
            faq={[
              {
                question: t("collection.service.marketing.faq.0.question"),
                answer: t("collection.service.marketing.faq.0.answer"),
              },
              {
                question: t("collection.service.marketing.faq.1.question"),
                answer: t("collection.service.marketing.faq.1.answer"),
              },
              {
                question: t("collection.service.marketing.faq.2.question"),
                answer: t("collection.service.marketing.faq.2.answer"),
              },
              {
                question: t("collection.service.marketing.faq.3.question"),
                answer: t("collection.service.marketing.faq.3.answer"),
              },
              {
                question: t("collection.service.marketing.faq.4.question"),
                answer: t("collection.service.marketing.faq.4.answer"),
              },
              {
                question: t("collection.service.marketing.faq.6.question"),
                answer: t("collection.service.marketing.faq.6.answer"),
              },
              {
                question: t("collection.service.marketing.faq.7.question"),
                answer: t("collection.service.marketing.faq.7.answer"),
              },
            ]}
          />
        }
      />
      <Route
        path="credits_account"
        element={
          <TakyonServicesTemplate
            title={t("collection.service.credits_account.title")}
            subtitle={t("collection.service.credits_account.subtitle")}
            buttonText={t("collection.service.credits_account.buttonText")}
            buttonLink={{
              type: 0,
              link: "https://meetings-eu1.hubspot.com/simona-graziani",
            }}
            buttonSubtext={""}
            descriptionTitle={t(
              "collection.service.credits_account.descriptionTitle"
            )}
            descriptionText={t(
              "collection.service.credits_account.descriptionText"
            )}
            features={[
              {
                title: t("collection.service.credits_account.features.0.title"),
                description: t(
                  "collection.service.credits_account.features.0.description"
                ),
              },
              {
                title: t("collection.service.credits_account.features.1.title"),
                description: t(
                  "collection.service.credits_account.features.1.description"
                ),
              },
              {
                title: t("collection.service.credits_account.features.2.title"),
                description: t(
                  "collection.service.credits_account.features.2.description"
                ),
              },
              {
                title: t("collection.service.credits_account.features.3.title"),
                description: t(
                  "collection.service.credits_account.features.3.description"
                ),
              },
            ]}
            faq={[
              {
                question: t(
                  "collection.service.credits_account.faq.0.question"
                ),
                answer: t("collection.service.credits_account.faq.0.answer"),
              },
              {
                question: t(
                  "collection.service.credits_account.faq.1.question"
                ),
                answer: t("collection.service.credits_account.faq.1.answer"),
              },
              {
                question: t(
                  "collection.service.credits_account.faq.2.question"
                ),
                answer: t("collection.service.credits_account.faq.2.answer"),
              },
              {
                question: t(
                  "collection.service.credits_account.faq.3.question"
                ),
                answer: t("collection.service.credits_account.faq.3.answer"),
              },
              {
                question: t(
                  "collection.service.credits_account.faq.4.question"
                ),
                answer: t("collection.service.credits_account.faq.4.answer"),
              },
              {
                question: t(
                  "collection.service.credits_account.faq.6.question"
                ),
                answer: t("collection.service.credits_account.faq.6.answer"),
              },
              {
                question: t(
                  "collection.service.credits_account.faq.7.question"
                ),
                answer: t("collection.service.credits_account.faq.7.answer"),
              },
            ]}
          />
        }
      />
      {/* <Route
        path="all"
        element={
          <TakyonServicesTemplate
            title={t("collection.service.all.title")}
            subtitle={""}
            buttonText={""}
            buttonSubtext={""}
            descriptionTitle={""}
            descriptionText={""}
            features={[]}
            faq={[]}
          />
        }
      /> */}
    </Routes>
  );
}
